import React, { useState } from "react";
import {
  buildRetirementDetailsUrl,
  formatRetirementDate,
  formatRetirementNumber,
} from "../../config/wilder_requests";
import { copyTxidAndOpenWilderExplorer } from "../../utils/wilderTxExplorer";
import {
  RetirementCard,
  RetirementCardHeader,
  RetirementCardTitle,
  RetirementCardBody,
  RetirementPurposeSection,
  RetirementCardFooter,
  RetirementCardActionsSlot,
  RetirementStatusTag,
  RetirementBadges,
  RetirementBadge,
  RetirementBadgeMuted,
  RetirementMetaGrid,
  RetirementMetaItem,
  RetirementPurpose,
  RetirementQuantity,
  RetirementCardActions,
  ProjectCardActionGhost,
} from "./styles";
import { useLanguage } from "../../contexts/LanguageContext";
import { getTranslation } from "../../locales";

export default function B4RetirementCard({ retirement: r, onTxidCopied }) {
  const { language } = useLanguage();
  const t = getTranslation(language).carbonRetirements;
  const [purposeExpanded, setPurposeExpanded] = useState(false);

  const purpose = r.Purpose || r.Notes || "";
  const dateBR = formatRetirementDate(r["Created Date"]);
  const quantity = formatRetirementNumber(r.Quantity);
  const retirementDetailsUrl = buildRetirementDetailsUrl(r._id);
  const hasActions = Boolean(r.certificate || retirementDetailsUrl || r.txid);

  const handleWilderExplorer = async () => {
    if (!r.txid) return;

    const result = await copyTxidAndOpenWilderExplorer(r.txid);
    onTxidCopied?.(result.ok ? "success" : "error");
  };

  return (
    <RetirementCard>
      <RetirementCardHeader>
        <RetirementStatusTag>{t.statusRetired}</RetirementStatusTag>
        <RetirementCardTitle title={r["Asset name"] || ""}>
          {r["Asset name"] || "—"}
        </RetirementCardTitle>
        <RetirementBadges>
          {r.Standard ? (
            <RetirementBadge title={r.Standard}>{r.Standard}</RetirementBadge>
          ) : null}
          {r.Vintage ? (
            <RetirementBadgeMuted title={String(r.Vintage)}>
              {r.Vintage}
            </RetirementBadgeMuted>
          ) : null}
          {r["Asset Type"] ? (
            <RetirementBadgeMuted title={r["Asset Type"]}>
              {r["Asset Type"]}
            </RetirementBadgeMuted>
          ) : null}
        </RetirementBadges>
      </RetirementCardHeader>

      <RetirementCardBody>
        <RetirementMetaGrid>
          <RetirementMetaItem>
            <small>{t.projectType}</small>
            <p title={r["Project type"] || ""}>{r["Project type"] || "—"}</p>
          </RetirementMetaItem>
          <RetirementMetaItem>
            <small>{t.createdDate}</small>
            <p>{dateBR}</p>
          </RetirementMetaItem>
          <RetirementMetaItem>
            <small>{t.beneficiary}</small>
            <p title={r.Beneficiary || ""}>{r.Beneficiary || "—"}</p>
          </RetirementMetaItem>
          <RetirementMetaItem>
            <small>{t.retiree}</small>
            <p title={r.Retiree || ""}>{r.Retiree || "—"}</p>
          </RetirementMetaItem>
        </RetirementMetaGrid>

        <RetirementPurposeSection>
          <RetirementMetaItem>
            <small>{t.purpose}</small>
            <RetirementPurpose
              $expanded={purposeExpanded}
              title={purpose || undefined}
            >
              {purpose || "—"}
            </RetirementPurpose>
          </RetirementMetaItem>
          {purpose.length > 120 ? (
            <button
              type="button"
              onClick={() => setPurposeExpanded((v) => !v)}
              style={{
                marginTop: "0.35rem",
                background: "none",
                border: "none",
                padding: 0,
                color: "#10b7a6",
                fontSize: "0.78rem",
                fontWeight: 600,
                cursor: "pointer",
                alignSelf: "flex-start",
              }}
            >
              {purposeExpanded ? t.showLess : t.showMore}
            </button>
          ) : null}
        </RetirementPurposeSection>
      </RetirementCardBody>

      <RetirementCardFooter>
        <RetirementQuantity>
          <strong>{quantity}</strong>
          <span>{t.creditsRetired}</span>
        </RetirementQuantity>

        <RetirementCardActionsSlot>
          {hasActions ? (
            <RetirementCardActions style={{ marginTop: 0, paddingTop: 0 }}>
              {r.certificate ? (
                <ProjectCardActionGhost
                  as="a"
                  href={r.certificate}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t.viewCertificate}
                </ProjectCardActionGhost>
              ) : null}
              {retirementDetailsUrl ? (
                <ProjectCardActionGhost
                  as="a"
                  href={retirementDetailsUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t.viewTxid}
                </ProjectCardActionGhost>
              ) : null}
              {r.txid ? (
                <ProjectCardActionGhost type="button" onClick={handleWilderExplorer}>
                  {t.viewBlockExplorer}
                </ProjectCardActionGhost>
              ) : null}
            </RetirementCardActions>
          ) : null}
        </RetirementCardActionsSlot>
      </RetirementCardFooter>
    </RetirementCard>
  );
}
